import React from "react";
import { HomePrivacyPoliciesUI } from "./HomePrivacyPoliciesUI";

function HomePrivacyPolicies() {
    return (
        <HomePrivacyPoliciesUI />
    );
}

export { HomePrivacyPolicies }